import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import { Loading, EmptyState } from "@/components/kit";
import { History as HistoryIcon } from "lucide-react";

export default function History() {
  const [list, setList] = useState(null);
  useEffect(() => { api.coachCheckinHistory().then(setList).catch(() => setList([])); }, []);

  return (
    <div className="space-y-5 fade-in">
      <div>
        <div className="hsc-label">Coach</div>
        <h1 className="font-display text-3xl text-white">Riwayat Check-in</h1>
      </div>
      {list === null ? <Loading /> : !list.length ? <EmptyState icon={HistoryIcon} title="Belum ada riwayat" /> : (
        <div className="space-y-2">
          {list.map((c, i) => (
            <div key={i} className="flex items-center justify-between rounded-lg border border-[#141416] px-3 py-2.5 text-sm">
              <div><div className="text-white">{c.class_name || c.area}</div><div className="text-[11px] text-[#6E6E73]">{c.member_name}</div></div>
              <span className="text-[11px] text-[#6E6E73]">{formatDateTime(c.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
